// store/modules/sse.js
// 存储接收到的 SSE 消息
const state = {
    sseMessages: [],
};

// 更新 SSE 消息
const mutations = {
    updateSseMessages(state, messages) {
        state.sseMessages = [...state.sseMessages, ...messages];
    },
};

// 更新 SSE 消息,如果是单个消息，封装成数组传递
const actions = {
    updateSseMessage({ commit }, message) {
        commit('updateSseMessages', [message]);
    },
};

// 获取所有的 SSE 消息
const getters = {
    allSseMessages(state) {
        return state.sseMessages;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
